var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 16.5H3.5C2.11929 16.5 1 17.6193 1 19C1 20.3807 2.11929 21.5 3.5 21.5H18",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 21.5C16.6193 21.5 15.5 20.3807 15.5 19C15.5 17.6193 16.6193 16.5 18 16.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4336 10.4997C11.8683 11.4379 10.8396 12.0654 9.66436 12.0654C7.88006 12.0654 6.43359 10.619 6.43359 8.83466C6.43359 7.65943 7.06109 6.63077 7.99932 6.06543",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M11 7.5H11.009",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1 19V5C1 3.067 2.567 1.5 4.5 1.5H14.5C16.433 1.5 18 3.067 18 5V16.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon4);
export default __webpack_public_path__ + "static/media/LineIcon4.6a3af0c31e70ef51dfbf2493c815e133.svg";
export { ForwardRef as ReactComponent };